import secureLocalStorage from "react-secure-storage";
import React, { Component, createRef } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Dialog, Window } from "@progress/kendo-react-dialogs";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { toastr } from "react-redux-toastr";
import Images from "../../../Assets/Images";
import Api from "../../../Services/Api";
import { Popup } from "@progress/kendo-react-popup";
import { CircularProgress } from "@material-ui/core";
import { TextArea } from "@progress/kendo-react-inputs";
import "../../Styles/ImpactTemplate.scss";
const threshHoldList = [
  { value: "VMS", displayName: "Very Much Stronger" },
  { value: "MS", displayName: "Much Stronger" },
  { value: "S", displayName: "Stronger" },
  { value: "N", displayName: "Neutral" },
  { value: "W", displayName: "Weaker" },
  { value: "MW", displayName: "Much Weaker" },
  { value: "VMW", displayName: "Very Much Weaker" },
];
const defaultItem={value: "Select Preference", displayName: "Select Preference"} ;

export default class ImpactTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      data: [],
      editID: null,
      impactList: [],
      value: [],
      visibleTemplate: false,
      tableValue: [],
      templateName: "",
      showWeightage: false,
      conststancyRatio: 0,
      impactRatios: [],
      templateList: [],
      openDeleteModelFlagView: false,
      isEdit: false,
      isCalculated: true,
      skip: 0,
      take: 10,
      description:""
    };
    this.refcalculate=React.createRef();
  }
  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };
  componentDidMount() {
    this.getAllImpacts();
    this.getAllPrimeMatrix();
  }
  getAllPrimeMatrix = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      let response = await Api.GetAllPrimeMatrix();
      if (response.status === 200 && response.primeResponses) {
        this.setState({
          ...this.state,
          loader: false,
          templateList: response.primeResponses,
        });
      } else {
        this.setState({ ...this.state, loader: false, templateList: [] });
      }
    } catch (err) {
      console.error(err);
    }
  };
  getAllImpacts = async () => {
    try {
      let response = await Api.GetAllImpactAndThreshold();
      if (response.status === 200 && response.impact) {
        let list = [];
        response.impact.map((item) => {
          list.push({
            value: item.impactId,
            text: item.name,
            checked: false,
          });
        });
        this.setState({ impactList: list });
      }
    } catch (err) {
      console.error(err);
    }
  };
  getImapctName = (id) => {
    let name = "";
    let impact =
      this.state.impactList &&
      this.state.impactList.find((item) => item.value == id);
    if (impact) {
      name = impact.text;
    }
    return name;
  };
  toggleTemplateDialogOpen = () => {
    this.setState({
      visibleTemplate: true,
    });
  };
  toggleTemplateDialogClose = () => {
    this.setState({
      visibleTemplate: false,
      templateName: "",
      value: [],
      tableValue: [],
      showWeightage: false,
      isEdit: false,
      description:""
    });
  };

  handleChange = (event) => {
    let list = event.target.value;
    let cols = [];
    list.map((item) => {
      if (item) {
        cols.push({
          impactName: item.text,
          impactid: item.value,
          threshHolds: this.getThreshHold(list),
        });
      }
    });
    this.setState({
      value: event.target.value,
      tableValue: [...cols],
    });
  };

  getThreshHold = (list) => {
    let ls = [];
    list.map((item) => {
      if (item) {
        ls.push({
          threshHoldValue: "",
          impactid: item.value,
          impactName: item.text,
        });
      }
    });
    return ls;
  };

  itemRender = (li, itemProps) => {
    const itemChildren = (
      <span>
        <input
          type="checkbox"
          checked={itemProps.selected}
          onChange={() => {}}
        />
        &nbsp;{li.props.children}
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  handleThreshholdChange = (e, index1, index2) => {
    let tableValue = this.state.tableValue;
    tableValue.map((item, idx1) => {
      if (index2 == idx1) {
        item.threshHolds &&
          item.threshHolds.map((thr, idx2) => {
            if (index1 === idx2) {
              thr["threshHoldValue"] = this.getPreferenceValue(e.value.value);
            }
          });
      } else if (index1 === idx1) {
        item.threshHolds &&
          item.threshHolds.map((thr, idx) => {
            if (index2 === idx) {
              thr["threshHoldValue"] = e.value.value;
            }
          });
      }
    });
    this.setState({ ...this.state, tableValue: tableValue });
  };
  getPreferenceValue = (val) => {
    let res = "";
    if (val === "VMS") {
      res = "Very Much Weaker";
    } else if (val === "MS") {
      res = "Much Weaker";
    } else if (val === "S") {
      res = "Weaker";
    } else if (val === "W") {
      res = "Stronger";
    } else if (val === "MW") {
      res = "Much Stronger";
    } else if (val === "VMW") {
      res = "Very Much Stronger";
    } else if (val === "N") {
      res = "Neutral";
    }

    return res;
  };
  validateCalculationTable = (table) => {
    let flag = false;
    if (!this.state.templateName) {
      flag = true;
    } else {
      let tableValue = this.state.tableValue;
      tableValue.map((item, idx1) => {
        item.threshHolds &&
          item.threshHolds.map((thr, idx2) => {
            if (idx1 != idx2) {
              if (thr.threshHoldValue == "") {
                flag = true;
              }
            }
          });
      });
    }
    return flag;
  };
  


  calculate = async () => {
    try {


      let flag = await this.validateCalculationTable(this.state.tableValue);
      if (flag) {
        toastr.error("Please enter all the fields");
        return;
      }
      this.setState({ ...this.state, loader: true });
      let req = {
        templateName: this.state.templateName,
        tableRequest: this.state.tableValue,
        createdDate: new Date(),
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
    
      
      let response = await Api.calculateWeightages(req);
      if (response.status === 200) {
    
        this.setState({
          ...this.state,
          loader: false,
          showWeightage: true,
          conststancyRatio: response.conststancyRatio,
          impactRatios: response.impactRatios,
          isCalculated: false,
        });
        this.refcalculate.current.scrollIntoView();

        // toastr.success(response.message);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }

    } catch (err) {
      console.error(err);
    }
  };
  savePrimeCalculation = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      let req = {
        name: this.state.templateName,
        tableRequest: this.state.tableValue,
        createdDate: new Date(),
        description:this.state.description,
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
     
      let response = await Api.AddPrimeMatrix(req);
      if (response.status === 200) {
        toastr.success(response.message);
        this.toggleTemplateDialogClose();
        this.getAllPrimeMatrix();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (err) {
      console.error(err);
    }
  };
  updatePrimeCalculation = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      let req = {
        Id: this.state.templateData.id,
        name: this.state.templateName,
        description:this.state.description,
        tableRequest: this.state.tableValue,
        UpdatedDate: new Date(),
        UpdatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      let response = await Api.UpdatePrimeMatrix(req);
      if (response.status === 200) {
        toastr.success(response.message);
        this.toggleTemplateDialogClose();
        this.getAllPrimeMatrix();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (err) {
      console.error(err);
    }
  };
  openDeletePopup = (data) => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: true,
      templateData: data,
    });
  };
  closeDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: false,
      templateData: null,
    });
  };

  deletePrimeMatrix = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      let req = {
        Id: this.state.templateData.id,
        DeletedDate: new Date(),
        DeletedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
     
      let response = await Api.DeletePrimeMatrix(req);
      if (response.status === 200) {
        toastr.success(response.message);
        this.closeDeletePopup();
        this.getAllPrimeMatrix();
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (err) {
      console.error(err);
    }
  };
  papulateTable = (obj) => {
    let list = [];
    obj.tableRequests.map((item1) => {
      let impacts = this.state.impactList.find(
        (imp) => imp.value == item1.impactid
      );
      list.push(impacts);
      item1["impactName"] = this.getImapctName(item1.impactid);
      item1.threshHolds.map((item2) => {
        item2["impactName"] = this.getImapctName(item1.impactid);
        return item2;
      });
      return item1;
    });
    this.setState({
      ...this.state,
      visibleTemplate: true,
      tableValue: obj.tableRequests,
      templateName: obj.name,
      value: list,
      templateData: obj,
      isEdit: true,
      showWeightage: true,
      impactRatios: obj.impactRatios,
      conststancyRatio: obj.conststancyRatio,
      isCalculated: true,
      description:obj.description
    });
  };

  getValueFromName(str) {
    let val = threshHoldList.find((item) => item.value === str);
    return val ? val : defaultItem;
  }

  handleDescription=(e)=>{
    this.setState({
      ...this.state,
      description: e.value,
    })
  }
  render() {
    const value = this.state.value;
    const selected = value.length;
    const tableValue = this.state.tableValue;
   
    return (
      <div className="dataGrids">
        <div className="impactTemplate">
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="impactsHeader primeTab">
            <h4>Prime Impact Template</h4>
            <div className="addImpactrow">
              <button
                title="Add new"
                className="addthreshold"
                onClick={this.toggleTemplateDialogOpen}
              >
                Add Prime Template
              </button>
            </div>
          </div>
          <Grid
            
            data={this.state.templateList.slice(
              this.state.skip,
              this.state.take + this.state.skip
            )}
            skip={this.state.skip}
            take={this.state.take}
            total={this.state.templateList.length}
            onPageChange={this.pageChange}
            pageable={true}
            
          >
            <Column field="name" title="name" width="200px" />
            
            <Column field="description" title="description" width="300px"
            cell={(props) => (
              <td title={props.dataItem.description}>
                {props.dataItem.description}
              </td>
            )}
             />
            <Column
              field="tableRequests"
              title="variables"
              cell={(props) => (
                <td>
                  {props.dataItem.tableRequests.map((item) => (
                    <span>{this.getImapctName(item.impactid)},</span>
                  ))}
                </td>
              )}
            />
            <Column
              field="conststancyRatio"
              title="consistency ratio"
              width="120px"
            />
            {/* <Column field="created" title="created by" width="100px" /> */}
            <Column
              title="Actions"
              width="80px"
              cell={(props) => (
                <td>
                  <ul className="actionIcon">
                    <li>
                      <a
                        title="Edit"
                        onClick={() => this.papulateTable(props.dataItem)}
                      >
                        <img src={Images.EDITICON} width="10" alt="Edit" />
                      </a>
                    </li>
                    <li>
                      <a
                        title="Delete"
                        onClick={() => this.openDeletePopup(props.dataItem)}
                      >
                        <img src={Images.TRASH} width="12" alt="Trash" />
                      </a>
                    </li>
                  </ul>
                </td>
              )}
            />
          </Grid>

          {this.state.visibleTemplate && (
            <Dialog>
              <div className="templateDialog">
                {this.state.loader ? (
                  <span className="MatTableSpinner">
                    <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
                  </span>
                ) : null}
                <h3>Add Prime Template</h3>
                <div className="it-form">
                  <div className="it-field-container">
                    <label>Template Name</label>
                    <input
                      type="text"
                      name="name"
                      value={this.state.templateName}
                      className="form-control"
                      onChange={(e) =>
                        this.setState({
                          ...this.state,
                          templateName: e.target.value,
                        })
                      }
                    />
                  </div>
                
                  <div className="it-field-container">
                    <label>Impacts</label>
                    <MultiSelect
                      id="value"
                      onChange={this.handleChange}
                      itemRender={this.itemRender}
                      value={value}
                      data={this.state.impactList}
                      valueField="value"
                      textField="text"
                      autoClose={false}
                      tags={
                        selected > 0
                          ? [
                              {
                                text: `${selected} items selected`,
                                data: [...value],
                              },
                            ]
                          : []
                      }
                    />
                  </div>
                  <div className="it-field-container" title={this.state.description}>
                  <label  > Description</label> 
                  <TextArea 
                  rows={1}
                  style={{display:'flex',color:'#ffffffb3',fontSize:'small'}}
                  maxlength={300}
                  value={this.state.description}
                  onChange={this.handleDescription}
                />
                  </div>
                </div>

                <div className="keydrivers" style={{height:'fit-content'}}>
                  <div className="sidebar">
                    <div className="title menu">Impacts</div>
                    {tableValue.map((impact) => (
                      <div className="subhead menu" style={{fontSize:'15px'}}>{impact.impactName}</div>
                    ))}
                  </div>
                  <div className="mainBody">
                    {this.state.tableValue.map((column, index1) => (
                      <div className="column">
                        <div className="title menu" >{column.impactName}</div>
                        {column.threshHolds &&
                          column.threshHolds.map((thr, index2) => (
                            <div
                              className={
                                index1 === index2
                                  ? "neutral menu"
                                  : index1 > index2
                                  ? "active menu"
                                  : "disabled menu"
                              }
                            >
                              {index1 === index2 ? (
                                "Neutral"
                              ) : index1 < index2 ? (
                                thr.threshHoldValue
                              ) : (
                               
                                <DropDownList
                                  className="templatePref"
                                  style={{ width: "160px" }}
                                  defaultItem={defaultItem}
                                  onChange={(e) =>
                                    this.handleThreshholdChange(
                                      e,
                                      index1,
                                      index2
                                    )
                                  }
                                  value={this.getValueFromName(
                                    thr.threshHoldValue
                                  )}
                                  // value="value"
                                  data={threshHoldList}
                                  textField="displayName"
                                  disabled={
                                    index1 < index2 || index1 === index2
                                  }
                                 
                                />
                              )}
                            </div>
                          ))}
                      </div>
                    ))}
                  </div>
                </div>
                Note:<small>Selected Preferences are towards the variable appearing in row against the variable in column. For example, if Variable 1 is in the row and Variable 2 is in the column and the preference in corresponding cell is "Very Much Stronger", it means Variable 1 has very much stronger preference over Variable 2.</small>

                <div className="btnfield_">
               
                <div className="btn-container">
                  <button
                   
                    className="btn-primary"
                    type="button"
                    onClick={this.calculate}
                  >

                    Calculate
                  </button>
                  <button
                    className="btn-cancel"
                    type="button"
                    onClick={this.toggleTemplateDialogClose}
                  >
                    Cancel
                  </button>
                </div>
                </div>
                <div ref={this.refcalculate}>
                {this.state.showWeightage && (
                  <div>
                    <div className="weightages" >
                      <h3>Prime Weightings</h3>
                      <br></br>
                      <div className="row">
                        <div className="col-lg-8 col-md-8  col-sm-12">
                          <Grid
                            style={{
                              minHeight: "200px",
                            }}
                            data={this.state.impactRatios}
                          >
                            {/* <Column field="name" title="Sl.No" width="200px" /> */}
                            <Column
                              field="impactVariable"
                              title="Impact variable"
                              width="160px"
                            />
                            <Column
                              field="ratio"
                              title="Weighting"
                              width="120px"
                            />
                          </Grid>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                          <div className="ratio_block">
                            <div
                              className={
                                this.state.conststancyRatio < 10
                                  ? "content_block_green"
                                  : "content_block_red"
                              }
                            >
                              <h2>{this.state.conststancyRatio}</h2>
                              <span>Consistency Ratio</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="btn-container">
                      <button
                        className="btn-primary"
                        type="button"
                        onClick={
                          this.state.isEdit
                            ? this.updatePrimeCalculation
                            : this.savePrimeCalculation
                        }
                        disabled={this.state.isCalculated}
                      >
                        {this.state.isEdit ? "Update" : "Create"}
                      </button>
                      <button
                        className="btn-cancel"
                        type="button"
                        onClick={this.toggleTemplateDialogClose}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>
              </div>
            </Dialog>
          )}

          <Popup
            show={this.state.openDeleteModelFlagView}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this Template?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.deletePrimeMatrix()}
                  className="deleteBtn"
                  type="button"
                >
                  Delete
                </button>
                <button
                  onClick={this.closeDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </Popup>
        </div>
      </div>
    );
  }
}